import jwtDecode from 'jwt-decode';

export class JwtHelper {

    // tokenDecoded: { exp: number, iat: number, profile: any, roles: string[], username: string };
    public static GetProfile(token: string) {

        const tokenDecoded: any = jwtDecode(token);
        return tokenDecoded ? tokenDecoded.profile : null;
    }

    public static IsExpired(token: string) {

        const tokenDecoded: any = jwtDecode(token);
        const expiry = tokenDecoded.exp;

        return (Math.floor((new Date()).getTime() / 1000)) >= expiry;
    }

    public static GetExpirationTime(token: string, ms = true): number {

      const tokenDecoded: any = jwtDecode(token);
      const expiry = tokenDecoded.exp;
      const diff = expiry - Math.floor( (new Date() ).getTime()/ 1000 );

      return ms ? 1000 * diff : diff;
    }

}
